<template>
  <div class="lec-home-wtxh">
    <TopBarWtxh />
    <!-- 讲师信息卡片 -->
    <div class="profile-section">
      <div class="profile-card">
        <div class="profile-avatar">
          <img v-if="lecInfo.avatar" :src="lecInfo.avatar" />
          <img v-else src="@/assets/per_img.png" />
        </div>
        <div class="profile-info">
          <p class="profile-name">{{ lecInfo.name }}</p>
          <div class="info-group" v-if="lecInfo.tags && lecInfo.tags.length">
            <p class="info-label">专业领域</p>
            <p class="info-value">{{ lecInfo.tags.join('、') }}</p>
          </div>
          <div class="info-group" v-if="lecInfo.teacher_tags && lecInfo.teacher_tags.length">
            <p class="info-label">绝技绝活</p>
            <p class="info-value">{{ lecInfo.teacher_tags.join('、') }}</p>
          </div>
          <div class="info-group" v-if="lecInfo.teach_direction && lecInfo.teach_direction.length">
            <p class="info-label">主攻方向</p>
            <p class="info-value">{{ lecInfo.teach_direction.join('、') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 讲师介绍 -->
    <div class="introduce-section">
      <p class="introduce-text" v-if="lecInfo.introduce">{{ lecInfo.introduce }}</p>
    </div>
    <BottomWtxhM />
  </div>
</template>

<script>
import TopBarWtxh from "@/m/common/topBarWtxh.vue";
import BottomWtxhM from "@/m/common/bottomWtxhM.vue";

export default {
  name: "LecHomeWtxh",
  components: {
    TopBarWtxh,
    BottomWtxhM,
  },
  data() {
    return {
      lecId: "",
      lecInfo: "",
    };
  },
  mounted() {
    this.lecId = this.$route.params.id;
    this.getLecInfo();
  },
  methods: {
    getLecInfo() {
      this.$axios.post(`/v1/teacher/detail`, { id: this.lecId }).then((res) => {
        this.lecInfo = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.lec-home-wtxh {
  background-color: rgba(247, 251, 252, 1);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.profile-section {
  background-image: url(~@/assets/m/lecturer_detail_bg.png);
  background-size: cover;
  background-position: center;
  padding: 40px 32px 40px 32px;
}
.profile-card {
  display: flex;
  align-items: flex-start;
}
.profile-avatar {
  width: 330px;
  height: 478px;
  flex-shrink: 0;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.profile-info {
  margin-left: 24px;
  padding-top: 16px;
  flex: 1;
  overflow: hidden;
}
.info-group {
  visibility: hidden;
}
.profile-name {
  font-size: 32px;
  font-family: PingFang-SC-Heavy, "PingFang SC", sans-serif;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  margin-bottom: 8px;
}
.info-label {
  font-size: 28px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(238, 238, 238, 1);
  line-height: 40px;
  margin-top: 24px;
}
.info-value {
  font-size: 24px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(226, 226, 226, 1);
  line-height: 40px;
  margin-top: 6px;
  word-break: break-all;
}
.introduce-section {
  padding: 48px 44px;
  flex: 1;
}
.introduce-text {
  font-size: 28px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(108, 110, 116, 1);
  line-height: 52px;
  text-align: justify;
}
</style>
